/**
 * カメラのパーミッションを返却する
 *
 * 「許可なし」を選択済み、もしくは、未選択の場合は、パーミッション要求をトライする
 */
export async function isCameraAuthorized(): Promise<boolean> {
  return await new Promise<boolean>((resolve, reject) => {
    // @ts-ignore
    if (window.cordova === undefined) {
      reject();
      return;
    }
    // @ts-ignore
    const diagnostic = cordova.plugins.diagnostic;
    if (diagnostic === undefined) {
      reject();
      return;
    }

    diagnostic.isCameraAuthorized(
      function(authorized: boolean) {
        if (authorized) {
          // 許可済みの場合
          resolve(true);
        } else {
          // 許可なし or 未選択の場合
          diagnostic.requestCameraAuthorization(function(status: string) {
            resolve(status === diagnostic.permissionStatus.GRANTED);
          });
        }
      },
      function() {
        reject();
      },
      false
    );
  });
}

/**
 * アプリの設定画面に遷移
 */
export async function openApplicationSettings() {
  if (!window.cordova) return;
  return await new Promise<void>((resolve, reject) => {
    const diagnostic = window.cordova?.plugins?.diagnostic;
    if (!diagnostic) reject("diagnostic is undefined");
    diagnostic.switchToSettings(resolve, reject);
  });
}
